import { getHazardIcon } from "@/features/branding";
import { availableExposureHazards, type ExposureHazard, ExposuresByHazard, HazardPlusTotal, isExposureHazard, ReturnPeriod } from "@/features/pe_aldd";
import { Avatar } from "antd";
import { useDataColors } from "../useDataColors";
const ExposureHazardIcon = ({
  hazard,
  returnPeriod,
  exposures
}: {
  hazard: ExposureHazard;
  returnPeriod: ReturnPeriod;
  exposures: ExposuresByHazard;
}) => {
  const {
    exposure
  } = useDataColors();
  return <Avatar size={24} style={{
    backgroundColor: exposure[exposures[hazard][returnPeriod] ?? "?"]
  }} icon={getHazardIcon(hazard, {
    style: {
      color: "#FFFFFF",
      fontSize: 14
    }
  })} data-sentry-element="Avatar" data-sentry-component="ExposureHazardIcon" data-sentry-source-file="ExposureItemIcon.tsx" />;
};
const ExposureItemIcon = ({
  activeHazard,
  exposures,
  returnPeriod
}: {
  activeHazard: HazardPlusTotal;
  exposures: ExposuresByHazard;
  returnPeriod: ReturnPeriod;
}) => {
  if (activeHazard === "total") return <>
        {availableExposureHazards.map(h => h in exposures && <ExposureHazardIcon key={h} hazard={h} returnPeriod={returnPeriod} exposures={exposures} />)}
      </>;
  if (!isExposureHazard(activeHazard)) return null;
  return <ExposureHazardIcon hazard={activeHazard} returnPeriod={returnPeriod} exposures={exposures} data-sentry-element="ExposureHazardIcon" data-sentry-component="ExposureItemIcon" data-sentry-source-file="ExposureItemIcon.tsx" />;
};
export default ExposureItemIcon;